window.colorPairs = [
	["#5A91A7", "#CADFE7"], // 1 blue
	["#B15763", "#F0D6D9"],	// 2 red
	["#DEA207", "#FBE2A4"],	// 3 yellow
	["#97B371", "#D5E5C0"],	// 4 green
]

export function randomColor() {
	var random = Math.floor(Math.random() * colorPairs.length);
	var lastColor = localStorage.getItem('current-color');

	
	// console.log("random before: ",random);
	
	if(lastColor === null) {
		console.log("lastColor: ",lastColor);
		localStorage.setItem('current-color', random);
		console.log("color now: ",random);
	}
	else if(random === lastColor) {
		random++;
		random %= colorPairs.length;
		localStorage.setItem('current-color', random);
	}
	else {
		localStorage.setItem('current-color', random);
	}

	random %= colorPairs.length;
	document.documentElement.style.setProperty('--current-color', colorPairs[random][1]);
	document.documentElement.style.setProperty('--current-color-dark', colorPairs[random][0]);
}